import e from "./components/ReactSlider/ReactSlider.js";
export { default } from "./components/ReactSlider/ReactSlider.js";